import { Modal, ModalBody } from "reactstrap";
import { ErrorIcon } from "../../../../assets/icons";
import { ButtonLoading } from "../../../../components/buttons/button-loading";
import { useEffect, useState } from "react";

const BulkLoadErrors = (props) => {
  const { open, toggle, errorsModal } = props;
  const [dataError, setDataErrors] = useState([]);

  useEffect(() => {
    if (errorsModal[0]?.row !== null) {
      const flattenedData = errorsModal.reduce((accumulator, currentValue) => {
        return accumulator.concat(currentValue);
      }, []);
      setDataErrors(flattenedData);
    } else {
      const fixedData = errorsModal.map((errors)=>{
      const errorMessage = errors.message
      const regEx = /\((.*?)\)=\((.*?)\)/g
      const arrMessage= errorMessage.split(regEx)
      return {message: `El ${arrMessage[1]} ${arrMessage[2]} ya existe, por favor, intenta con otro.`, row: null}
      })
      setDataErrors(fixedData);
    }
  }, []);

  return (
    <Modal isOpen={open} toggle={toggle}>
      <div className="gm-modal-header">
        <div className="gm-modal-title-container">
          <div className="gm-modal-title-bulk">
            {" "}
            <ErrorIcon /> Error de Carga
          </div>
        </div>
        <button
          type="button"
          className="btn-close"
          aria-label="Close"
          onClick={toggle}
        />
      </div>
      <ModalBody>
        <div className="gm-modal-bulk-container">
          <span className="gm-modal-span-bulk">
            Hay {dataError.length} errores encontrados
          </span>
          {dataError[0]?.row !== null ? (
            <table>
              <thead>
                <tr>
                  <th>Fila</th>
                  <th>Columna</th>
                  <th>Tipo de Error</th>
                </tr>
              </thead>
              <tbody>
                {dataError.map((elements) => (
                  <tr>
                    <th>{elements.row}</th>
                    <th>{elements.column}</th>
                    <th>
                      <span>{elements.message}</span>
                    </th>
                  </tr>
                ))}
              </tbody>
            </table>
          ) : (
            <ul>
              {dataError.map((element, index) => (
                <li key={index}>{element.message}</li>
              ))}
            </ul>
          )}
        </div>
        <form>
          <div className="gm-modal-buttons">
            <ButtonLoading
              className="gm-primary-button"
              type="submit"
              buttonLabel="Volver a Intentar"
              onClick={toggle}
            />
          </div>
        </form>
      </ModalBody>
    </Modal>
  );
};

export default BulkLoadErrors;
